<template>
  <v-card
    class="mb-5 pa-4 card-border"
    :class="publication.pinned ? 'card-border-green' : 'card-border-blue'"
  >
    <v-card-text class="pa-0">
      {{ getAuthor() }}
      <a v-if="publication.DOI" :href="`https://doi.org/${publication.DOI}`" target="_blank" v-html="getTitleHTML()"></a>
      <a v-else :href="publication.URL" target="_blank" v-html="getTitleHTML()"></a>
      {{ " " }}
      <i>{{ publication['container-title'] || publication["source"] }} </i>
      ({{ getYear() }}).
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

const ComponentProps = Vue.extend({
  props: ["publication"],
});

export default class Publication extends ComponentProps {
  private getTitleHTML(): string {
    return this.publication.title + "."
  }

  private getAuthor(): string {
    const lastNames = this.publication.author.map(author => author.family)
    if (lastNames.length === 0) {
      return ""
    }
    if (lastNames.length === 1) {
      return lastNames[0] + "."
    }
    if (lastNames.length === 2) {
      return lastNames[0] + " & " + lastNames[1] + "."
    }
    if (lastNames.length === 3) {
      return lastNames[0] + ", " + lastNames[1] + " & " + lastNames[2] + "."
    }
    return this.publication.author[0].family + " et al."
  }

  private getYear(): number {
    return this.publication.issued["date-parts"][0][0]
  }
}
</script>

<style scoped>
.card-border {
  border-left: 8px solid;
}

.card-border-blue {
  border-color: #1976d2; /* blue darken-2 */
}

.card-border-green {
  border-color: #388e3c; /* green darken-2 */
}
</style>
